var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDraggable = function SvgDraggable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.875 8.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m0 4.875a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M11 16.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m4.125-8.625a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M16.25 12A1.125 1.125 0 1 1 14 12a1.125 1.125 0 0 1 2.25 0m-1.125 6a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
  })));
};
export default SvgDraggable;